import React, { Component } from 'react';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import {
  Accordion,
  Button,
  Divider,
  Form,
  Grid,
  Header,
  Icon,
} from 'semantic-ui-react';
import moment from 'moment';
import { connect } from 'react-redux';

import { DatePickerField, CheckboxField } from 'Common/SemanticWrapper';
import { DatePickerCustomButton, TitledCard } from 'Components';
import { FifoEnum } from 'Common/FieldEnum';
import { ITEM_MAINTENANCE_FIFO_FORM_NAME } from 'Common/FormEnum';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';

import { getInventoryValue } from 'Common/FormHelper';
import { PrintGroupByTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { ReportGeneration } from 'Common/ObjectHelper';
import { toastInfo } from 'Common/ToastHelper';

import {
  printReportData,
  getFifoItems,
  clearReport,
} from './../state/addEditItem/actions';
import { validateFifoForm } from '../helpers';
import { FIFOTable } from './tables/FIFOTable';

const DATE = moment();

class FIFO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isGroupBySelected: FifoEnum.isGroupByItem,
      fromDateMin: null,
      fromDateMax: DATE,
      toDateMin: null,
      currentSystemDate: null,

      resetPageOnDataChange: true,
      activeIndexes: [0, 1],
    };
    this.reactTable = React.createRef();
  }

  printOptions = [
    { value: PrintGroupByTypeEnum.Item, label: 'Group By Item' },
    { value: PrintGroupByTypeEnum.Site, label: 'Group By Site' },
  ];

  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  componentDidMount() {
    this.getFilteredData();
  }

  componentDidUpdate(prevProps) {
    const { report } = this.props;
    if (prevProps.report !== report && report != null) {
      if (report) {
        ReportGeneration(report, 'FIFO Report');
      } else {
        toastInfo('No data found!');
      }
      this.props.clearReport();
    }
  }

  getFilteredData = (newValue, prevValue, field) => {
    const { beginDT, endDT, selectAll } = this.props;
    let beginDate = beginDT;
    let endDate = endDT;
    if (field === FifoEnum.BeginDT) {
      beginDate = newValue;
    }
    if (field === FifoEnum.EndDT) {
      endDate = newValue;
    }
    if (beginDate && endDate) {
      this.props.getFifoItems(
        this.props.id,
        moment(beginDate).format(DATE_FORMAT_FOR_SERVER),
        moment(endDate).format(DATE_FORMAT_FOR_SERVER),
        selectAll
      );
    }
  };

  setPrintOption = selected => {
    this.setState({
      isGroupBySelected: selected,
    });
  };

  selectFromDate(e, newValue, prevValue, field) {
    this.setState(
      {
        toDateMin: moment(newValue, DATE_FORMAT_FOR_UI),
        resetPageOnDataChange: true,
      },
      () => this.getFilteredData(newValue, prevValue, field)
    );
  }

  selectToDate(e, newValue, prevValue, field) {
    this.setState(
      {
        fromDateMax: moment(newValue, DATE_FORMAT_FOR_UI),
        resetPageOnDataChange: true,
      },
      () => this.getFilteredData(newValue, prevValue, field)
    );
  }

  clearFilters = () => {
    this.props.reset();
    this.setState({
      fromDateMax: DATE,
      fromDateMin: null,
      toDateMin: null,
    });
    this.props.getFifoItems(
      this.props.id,
      moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_SERVER),
      moment().format(DATE_FORMAT_FOR_SERVER),
      false
    );
  };

  onChangeOfFromDT = (e, beginDate, prevValue, field) => {
    this.selectFromDate(e, beginDate, prevValue, field);
  };

  onChangeOfToDT = (e, newValue, prevValue, field) => {
    this.selectToDate(e, newValue, prevValue, field);
  };

  print = () => {
    const { selectAll, beginDT, endDT, printOptions } = this.props;
    const input = {
      ItemId: this.props.id,
      FromDate: null,
      ToDate: null,
      selectall: true,
      IsFIFO: true,
      GroupBy: printOptions,
      TransactionType: null,
    };
    const payload = selectAll
      ? input
      : {
          ...input,
          selectall: false,
          FromDate: moment(beginDT).format(DATE_FORMAT_FOR_SERVER),
          ToDate: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
        };
    this.props.printReportData(payload);
  };

  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };

  handleChangeShowAll = (e, checked) => {
    const { beginDT, endDT } = this.props;
    if (beginDT && endDT) {
      this.props.getFifoItems(
        this.props.id,
        moment(beginDT).format(DATE_FORMAT_FOR_SERVER),
        moment(endDT).format(DATE_FORMAT_FOR_SERVER),
        checked
      );
    }
  };

  render() {
    const {
      printOptions,
      printLoading,
      selectAll,
      fetchingFifo,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      fifoItemsData,
    } = this.props;

    return (
      <Form>
        <Accordion fluid styled>
          <Accordion.Title
            active={this.state.activeIndexes.indexOf(0) !== -1}
            index={0}
            onClick={this.handleCollapsePanelClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Filter By</span>
          </Accordion.Title>

          <Accordion.Content
            active={this.state.activeIndexes.indexOf(0) !== -1}
          >
            <Grid className="grid-spacing">
              <Grid.Row columns={2}>
                <Grid.Column>
                  <div style={{ paddingTop: '25px' }}>
                    <Header as="h4">Transaction Date Range</Header>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    label={'From:'}
                    name={FifoEnum.BeginDT}
                    onChange={this.onChangeOfFromDT}
                    maxDate={this.state.fromDateMax}
                    minDate={this.state.fromDateMin}
                    type={'text'}
                    customInput={
                      <DatePickerCustomButton isDisabled={selectAll} />
                    }
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    label={'To:'}
                    name={FifoEnum.EndDT}
                    onChange={this.onChangeOfToDT}
                    minDate={this.state.toDateMin}
                    type={'text'}
                    customInput={
                      <DatePickerCustomButton isDisabled={selectAll} />
                    }
                  />
                </Grid.Column>

                <Grid.Column
                  width={4}
                  verticalAlign={'middle'}
                  style={{
                    marginTop: 36,
                  }}
                >
                  <Field
                    component={CheckboxField}
                    toggle
                    label={'Show All Dates'}
                    name={FifoEnum.SelectAll}
                    type={'checkbox'}
                    onChange={this.handleChangeShowAll}
                  />
                </Grid.Column>
                <Grid.Column
                  floated={'right'}
                  textAlign={'right'}
                  width={4}
                  verticalAlign={'middle'}
                  style={{
                    marginTop: 28,
                  }}
                >
                  <Button content="Clear Filters" onClick={this.clearFilters} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>

          <Accordion.Title
            active={this.state.activeIndexes.indexOf(1) !== -1}
            index={1}
            onClick={this.handleCollapsePanelClick}
          >
            <Icon name="dropdown" />
            <span className="text-orange">Print Options</span>
          </Accordion.Title>

          <Accordion.Content
            active={this.state.activeIndexes.indexOf(1) !== -1}
          >
            <Grid className="tight">
              <Grid.Row columns={2}>
                <Grid.Column width={14}>
                  <ReduxFormButtonGroup
                    options={this.printOptions}
                    value={printOptions}
                    formName={ITEM_MAINTENANCE_FIFO_FORM_NAME}
                    fieldName={FifoEnum.PrintOptions}
                  />
                </Grid.Column>
                <Grid.Column width={2} textAlign={'right'} floated={'right'}>
                  <Button
                    loading={printLoading}
                    type={'button'}
                    content="Print"
                    onClick={this.print}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>

        <Divider horizontal />
        <TitledCard>
          <Grid>
            <Grid.Row columns={1} className={'remove-spacing'}>
              <Grid.Column>
                <FIFOTable
                  fetchingFifo={fetchingFifo}
                  gridPreferenceLoading={gridPreferenceLoading}
                  gridPreferenceSubmitting={gridPreferenceSubmitting}
                  reactTableRef={this.reactTable}
                  fifoItemsData={fifoItemsData}
                  resetPageOnDataChange={this.state.resetPageOnDataChange}
                  onResetPageOnDataChange={this.onResetPageOnDataChange}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={16}>
              <Grid.Column width={12} />
              <Grid.Column width={4}>
                <span
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  Total Inv:{' '}
                </span>
                {getInventoryValue(this.props.fifoItemsData)}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </TitledCard>
      </Form>
    );
  }
}

const selector = formValueSelector(ITEM_MAINTENANCE_FIFO_FORM_NAME);
const mapStateToProps = state => {
  const { addEditItem } = state.ItemMaintenanceState;
  const { gridPreference } = state.CommonState;
  return {
    fifoItemsData: addEditItem.fifoItemsData,
    fetchingFifo: addEditItem.fetchingFifo,
    beginDT: selector(state, FifoEnum.BeginDT),
    endDT: selector(state, FifoEnum.EndDT),
    selectAll: selector(state, FifoEnum.SelectAll),
    printOptions: selector(state, FifoEnum.PrintOptions),
    gridPreferenceLoading: gridPreference.loading,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    printLoading: addEditItem.printLoading,
    report: addEditItem.report,
  };
};

FIFO = connect(mapStateToProps, {
  getFifoItems,
  printReportData,
  clearReport,
})(FIFO);
export default reduxForm({
  validate: validateFifoForm,
  destroyOnUnmount: false,
  form: ITEM_MAINTENANCE_FIFO_FORM_NAME,
})(FIFO);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/FIFO.js